import { AxiosError } from "axios";

export interface ServerErrorLogDetails {
  timestamp: string;
  url?: string;
  method?: string;
  status?: number;
  statusText?: string;
  requestParams?: Record<string, unknown>;
  requestBody?: unknown;
  responseData?: unknown;
  errorMessage: string;
  errorCode?: string;
  stack?: string;
}

/**
 * 记录服务端 API 错误的详细信息
 * @param error Axios 错误对象
 */
export function logServerError(error: AxiosError): void {
  const logDetails: ServerErrorLogDetails = {
    timestamp: new Date().toISOString(),
    url: error.config?.url,
    method: error.config?.method?.toUpperCase(),
    status: error.response?.status,
    statusText: error.response?.statusText,
    requestParams: error.config?.params,
    requestBody: error.config?.data,
    responseData: error.response?.data,
    errorMessage: error.message,
    errorCode: error.code,
    stack: error.stack,
  };

  try {
    console.error(
      "[API Error] Detailed error information:",
      JSON.stringify(logDetails, null, 2)
    );
  } catch (stringifyError) {
    console.error(
      "[API Error] Failed to stringify error details:",
      logDetails,
      "Stringify error:",
      stringifyError
    );
  }
}
